import React from "react";
import Ui from "./components/Ui";
import styles from "./App.module.css";

function App() {
  return (
    <>
      <div className={styles.textCenter}>
        <Ui />
      </div>
    </>
  );
}

export default App;
